import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-offer-how',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './offer-how.component.html',
  styleUrl: './offer-how.component.css',
})
export class OfferHowComponent {
  header = input<string>();
  bold1 = input<string>();
  text1 = input<string>();
  bold2 = input<string>();
  text2 = input<string>();
  bold3 = input<string>();
  text3 = input<string>();
  bold4 = input<string>();
  text4 = input<string>();
}
